export default __webpack_public_path__ + "static/media/oreoluwa.ccde127e.png";